import React from 'react';
import { Row, Col, Card, Avatar, Rate } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import './Testimonials.css';

interface Testimonial {
  name: string;
  location: string;
  content: string;
}

const Testimonials: React.FC = () => {
  const testimonials: Testimonial[] = [
    {
      name: '王先生',
      location: '章贡区现代简约三居室',
      content: '服务很好，施工专业，按时完成，效果超出预期！设计师很专业，施工团队也很负责。'
    },
    {
      name: '李女士',
      location: '经开区北欧风两居室',
      content: '性价比很高，推荐！从设计到施工都很专业，整个过程很顺利，没有任何问题。'
    },
    {
      name: '张女士',
      location: '蓉江新区新中式三居室',
      content: '非常满意，从设计到施工都很专业。师傅手艺很好，干活利索，推荐给大家！'
    }
  ];

  return (
    <section className="testimonials">
      <div className="container">
        <h2 className="section-title">用户评价</h2>
        <p className="section-subtitle">听听用户怎么说</p>

        <Row gutter={[32, 32]}>
          {testimonials.map((testimonial, index) => (
            <Col key={index} xs={24} sm={12} lg={8}>
              <Card
                className="testimonial-card"
                variant="borderless"
                hoverable
              >
                <div className="testimonial-stars">
                  <Rate disabled defaultValue={5} />
                </div>
                <p className="testimonial-content">{testimonial.content}</p>
                <div className="testimonial-user-info">
                  <Avatar
                    icon={<UserOutlined />}
                    size={48}
                    className="testimonial-avatar"
                  />
                  <div className="testimonial-user-details">
                    <div className="testimonial-user-name">{testimonial.name}</div>
                    <div className="testimonial-user-location">{testimonial.location}</div>
                  </div>
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    </section>
  );
};

export default Testimonials;
